import {
    GET_ASSET_FLEET_LINK_ATTACHMENT_SAVE,
    SET_ASSET_FLEET_LINK_ATTACHMENT_SAVE
} from "./AssetFleetProcessingLinkAttachmentType"

const getAssetFleetLinkAttachmentSave = (attachment: any) => ({
    type: GET_ASSET_FLEET_LINK_ATTACHMENT_SAVE,
    attachment
})

const setAssetFleetLinkAttachmentSave = (assetFleetLinkAttachmentSave: any) => ({
    type: SET_ASSET_FLEET_LINK_ATTACHMENT_SAVE,
    assetFleetLinkAttachmentSave: assetFleetLinkAttachmentSave
})

export {
    getAssetFleetLinkAttachmentSave,
    setAssetFleetLinkAttachmentSave
}